export enum SurveySendTimeOptions {
  ONE_MINUTE = "1 minute",
  FIVE_MINUTES = "5 minutes",
  THIRTY_MINUTES = "30 minutes",
  ONE_HOUR = "1 hour",
  TWO_HOURS = "2 hours",
  THREE_HOURS = "3 hours",
  FOUR_HOURS = "4 hours",
  SIX_HOURS = "6 hours",
  NINE_HOURS = "9 hours",
  TWELVE_HOURS = "12 hours",
  ONE_DAY = "1 day",
  TWO_DAYS = "2 days",
  THREE_DAYS = "3 days",
  SEVEN_DAYS = "7 days",
}

export type CsatSurveySendTime = SurveySendTimeOptions;
export const CSAT_SURVEY_SEND_TIME_OPTIONS: readonly SurveySendTimeOptions[] =
  Object.values(SurveySendTimeOptions);

export enum CsatSurveyMethod {
  REDO_CHAT = "redoChat",
  EMAIL = "email",
}

export const CSAT_SURVEY_METHODS: readonly CsatSurveyMethod[] =
  Object.values(CsatSurveyMethod);

/** Survey email body used until the merchant writes their own. */
export const DEFAULT_SURVEY_EMAIL_BODY_HTML =
  "<p>Your feedback is essential in helping us understand what we&#39;re doing well and where we can improve.</p><p>Please take a moment to share your feedback with a one-question survey.</p><p>How would you rate your service today?</p>";

const CSAT_SURVEY_SEND_TIME_SET: ReadonlySet<string> = new Set<string>(
  CSAT_SURVEY_SEND_TIME_OPTIONS,
);

/** Narrows a persisted string onto the send-time scale. */
export function isCsatSurveySendTime(
  value: string,
): value is CsatSurveySendTime {
  return CSAT_SURVEY_SEND_TIME_SET.has(value);
}

/** One arm of a CSAT survey A/B test. Unset fields fall back to team settings. */
export interface CsatSurveyVariant {
  id: string;
  name: string;
  /** Share of traffic, relative to the other variants. Zero never gets picked. */
  weight: number;
  surveySendTime?: CsatSurveySendTime;
  emailTemplateId?: string;
}
